
import CategoriesListMixin from '~/node_modules/sitis-nuxt/lib/mixins/CategoriesListMixin';
import CmsMetaMixin from '~/node_modules/sitis-nuxt/lib/mixins/CmsMetaMixin';

export default {
  name: 'Index',

  head: function () {
    const title = this.meta?.page?.title_tag || this.meta?.page?.title || this.$store?.state?.appState?.config?.siteName || '';
    const description = this.meta?.page?.description || '';
    return this.$seoMetaHelper({
      title: title,
      description: description,

      meta: [
        {
          name: 'og:title', hid: 'og:title', property: 'og:title', content: title,
        },

        { name: 'description', hid: 'metadescription', content: description },
        {
          name: 'og:description', hid: 'og:description', property: 'og:description', content: description,
        },
        { name: 'robots', content: 'noindex' },
      ],
    });
  },

  fetch: async function () {
    await this.loadMeta();
    await this.loadCatalog();
  },

  mixins: [
    CmsMetaMixin,
    CategoriesListMixin,
  ],

  computed: {
    breadcrumbs: function () {
      return [
        { title: 'Главная', path: '/' },
        { title: 'Каталог', path: '/catalog' },
      ];
    },

    // Данные по CMS контнеты
    cmsPageIdBottom: function () {
      return this.$store.state.appState?.vars?.['CMS PAGE ID для каталога (для главной страницы)'] || '';
    },
  },

  components: {
    Breadcrumbs: () => import('~/components/UI/Breadcrumbs'),
  },
};
